import React from "react";
import { FormContextProps } from "./Form.props";

/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultFormContextValue: FormContextProps<any> = {
  formState: {
    errors: {},
    dirtyFields: {},
    isDirty: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    isValidating: false,
    submitCount: 0,
    touchedFields: {},
    isLoading: false,
    disabled: false,
    validatingFields: {},
    isFormLoading: false,
    isReady: false,
  },
  readOnly: false,
} as FormContextProps<any>;

export const FormContext = React.createContext<FormContextProps<any>>(defaultFormContextValue);

/**
 * @deprecated
 */
export const FormContextProvider = FormContext.Provider;

/**
 * @deprecated
 */
export { Controller, useWatch, useFieldArray } from "react-hook-form";
